import axios from "axios";
import { attachAuthInterceptors } from "../utils/authSession";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

attachAuthInterceptors(api);

export default api;